import * as React from 'react';
import Box from '@mui/material/Box';
import { Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import { getIntlTranslation } from '../../../utils/helper';

function parseDefects(defectStr) {
    if (!defectStr || typeof defectStr !== "string") return [];

    // 0) Remove leading label like "Defects passed:" (optional)
    const s = defectStr.replace(/^[^:]*:\s*/, "").trim();
    if (!s) return [];

    const items = [];
    const seen = new Set();

    // 1) Try numbered list: "1. ... 2. ..."
    const numberedRe = /(?:^|\s)(\d+)\.\s([^]+?)(?=(?:\s*\d+\.\s)|$)/g;
    if (numberedRe.test(s)) {
        numberedRe.lastIndex = 0; // reset since we tested it
        let m;
        while ((m = numberedRe.exec(s)) !== null) {
            const idx = Number(m[1]);
            let raw = (m[2] || "").trim().replace(/[,\s]+$/g, "").trim();

            // Try to pull a trailing " - <label>"
            const match = raw.match(/^(.*?)(?:\s*-\s*([A-Za-zÄÖÜäöüß]+))?$/);
            let description = (match?.[1] || "").trim().replace(/^[, ]+|[, ]+$/g, "");
            const label = (match?.[2] || "").trim();

            let type = "";
            let severity;

            if (/^hinweis$/i.test(label)) type = "Hinweis";
            else if (/^mangel$/i.test(label)) type = "Mangel";
            else if (/^(einfach|mittel|hoch)$/i.test(label)) severity = label.toLowerCase();

            const key = description.toLowerCase().replace(/\s+/g, " ");
            if (!key || seen.has(key)) continue;
            seen.add(key);

            items.push({
                index: idx,
                description,
                type, // "Hinweis" | "Mangel" | ""
                ...(severity ? { severity } : {}),
            });
        }

        items.sort((a, b) => a.index - b.index);
        return items;
    }

    const bulletStarts = (s.match(/(^|\s)[-•]\s+/g) || []).length;
    const semicolons = (s.match(/;\s+/g) || []).length;

    if (bulletStarts >= 2 || semicolons >= 2) {
        const chunks = s
            .split(/(?:^|\s)[-•]\s+|;\s+/g)
            .map(t => t.trim())
            .filter(Boolean);

        chunks.forEach((raw, i) => {
            const match = raw.match(/^(.*?)(?:\s*-\s*([A-Za-zÄÖÜäöüß]+))?$/);
            let description = (match?.[1] || "").trim().replace(/^[, ]+|[, ]+$/g, "");
            const label = (match?.[2] || "").trim();

            let type = "";
            let severity;
            if (/^hinweis$/i.test(label)) type = "Hinweis";
            else if (/^mangel$/i.test(label)) type = "Mangel";
            else if (/^(einfach|mittel|hoch)$/i.test(label)) severity = label.toLowerCase();

            const key = description.toLowerCase().replace(/\s+/g, " ");
            if (!key || seen.has(key)) return;
            seen.add(key);

            items.push({
                index: i + 1,
                description,
                type,
                ...(severity ? { severity } : {}),
            });
        });

        return items;
    }

    const single = s.replace(/[,\s]+$/g, "").trim();
    if (!single) return [];
    return [{ index: 1, description: single, type: "" }];
}

const DefectList = ({ defects, onClose, elementDetails }) => {
    const [parsedDefects, setParsedDefects] = React.useState([])

    useEffect(() => {
        setParsedDefects(parseDefects(defects));
    }, [defects]);
    return (
        <Box sx={{ width: 300 }} role="presentation" >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant='h6'>
                    {getIntlTranslation("mi.defects-in")} {elementDetails.elementName}:
                </Typography>
                <IconButton size="small" onClick={onClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </Box>
            {parsedDefects.length > 0 ? (
                parsedDefects.map((defect) => (
                    <Box key={defect.index} sx={{ mb: 2 }}>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                            • {defect.description}
                        </Typography>
                    </Box>
                ))
            ) : (
                <Typography>{getIntlTranslation("mi.no-defects-found")}</Typography>
            )}
            {/* <Typography variant="h7" sx={{ fontWeight: 600, width: '100%', color: '#aa3939' }}>
                High Risks
            </Typography>
            <Typography>
                Disabled/isolated zones or devices
                Sound pressure level (SPL) below code
            </Typography>
            <Typography variant="h7" sx={{ fontWeight: 600, width: '100%', color: '#ffc924' }}>
                Medium Risks
            </Typography>
            <Typography>
                Inconsistent detector spacing in open areas
                Missing protective covers where prone to accidental activation
            </Typography>
            <Typography variant="h7" sx={{ fontWeight: 600, width: '100%', color: '#97b444' }}>
                Low Risks
            </Typography>
            <Typography>
                Worn or inconsistent device labels
                Test forms missing non-critical fields
            </Typography> */}
        </Box>
    );
}

export default DefectList;
